// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4f594416","79":"89b57b71","93":"a0059a35","312":"3f79be06","360":"dcb23efd","449":"9a56ffdf","470":"e745fe6b","492":"b9a0e4f5","521":"c304f97e","590":"cf93c330","598":"fc12611e","645":"26dd8012","852":"ff52f934"}[chunkId] + ".chunk.js";
};